import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { Order, OrderCollection } from '@/firestore'
import { dateService } from '@/services/date.service'

@Component
export default class OrderView extends Mixins(IconsMixin, AuthMixin) {
  public showDelivered: boolean = false
  public orders: Order[] = []
  public headers = [
    {text: '', sortable: false, value: 'icon'},
    {text: 'Order #', value: 'number'},
    {text: 'Status', value: 'status'},
    {text: 'Restaurant', value: 'restaurant'},
    {text: 'Date Expected', value: 'dateExpected'}
  ]

  public months = dateService.months('abbreviatedMonths')

  public async mounted() {
    const collection = new OrderCollection((await this.$firebase).firestore())

    if (this.userClaim.admin) {
      this.orders = collection.watchOrdersByCompanyId(this.userCompany.id)
    } else {
      this.orders = collection.watchVendorOrdersByVendorRepId(this.user.uid)
    }
  }

  public async viewOrder(order: Order) {
    await this.$router.push({name: 'vendor-order-details', params: {id: order.id}})
  }

  public get displayedOrders() {
    const filtered = this.orders.filter(
      (order) =>
        this.showDelivered
        || !order.isComplete
    )
    return filtered.sort((a: Order, b: Order) => {
      if (!a.dateExpected) {
        return 1
      } else if (!b.dateExpected) {
        return -1
      } else {
        return a.dateExpected.getTime() - b.dateExpected.getTime()
      }
    })
  }

  public convertToHeader(group: number) {
    if (!group || group === 1000000) {
      return 'No Date Found'
    }

    return `${this.months[parseInt(group.toString().slice(4)) - 1]} ${group.toString().slice(0, 4)}`
  }
}
